import { useEffect, useMemo, useState, useRef, useCallback } from "react";
import { DatePicker } from "antd-mobile";
// import { useNavigate } from "react-router-dom";
import Header from "../../components/header/header";
import "./customAnalysis.css";
import { Select, Segmented } from "antd";
import { DownOutlined } from "@ant-design/icons";
// 引入 ECharts 主模块
import * as echarts from "echarts";
import {
  getAnalysis,
  top_customer,
  upgrade_customer,
} from "../../api/customAnalysis";
import { useNavigate } from "react-router-dom";

export default function CustomAnalysisIndex() {
  const navigator = useNavigate();
  const now = useMemo(() => new Date(), []);
  const [timeMode, setTimeMode] = useState("本年");
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [tParam, setTParam] = useState({
    order: "出货量",
    top: "TOP20",
  });
  const [cParam, setCParam] = useState({
    order: "出货量",
    top: "TOP20",
    trend: "上升榜",
  });
  const [pickVisible, setPickVisible] = useState(false);
  // const [type2, setType2] = useState("上升榜");
  const [showFloat, setShowFloat] = useState(false);
  const [type, setType] = useState("客户分析");
  const top20Ref = useRef(null);
  const rankRef = useRef(null);
  const curr = useRef(null);
  const topRef = useRef(null);
  const [totalParam, setTotalParam] = useState({
    jml_growth_rate: 0,
    jxskz_growth_rate: 0,
    ssjt_count: 0,
    ssjt_count_growth_rate: 0,
    sum_jxskz: 0,
    sum_ml: 0,
    time: "",
  });
  const [topParam, setTopParam] = useState({
    cus_list: [],
    other_cus_jxskz: 0,
    other_cus_ml: 0,
    other_cus_ratio_kz: 0,
    other_cus_ratio_ml: 0,
    top_cus_jxskz: 0,
    top_cus_ml: 0,
    top_cus_ratio_kz: 0,
    top_cus_ratio_ml: 0,
  });
  let size = (window.innerWidth / 414) * 16;
  if (
    document.documentElement.clientHeight > document.documentElement.clientWidth
  ) {
    size = (window.innerWidth / 414) * 16;
  } else {
    size = (window.innerWidth / 1920) * 16;
  }

  const lastThreeMonths = useMemo(() => {
    const items = [];
    for (let offset = 2; offset >= 0; offset--) {
      const date = new Date(now.getFullYear(), now.getMonth() - offset, 1);
      items.push(`${date.getMonth() + 1}`);
    }
    return items;
  }, [now]);

  const currentLabel = useMemo(() => {
    if (timeMode === "本年") {
      return `${year}年`;
    }
    if (timeMode === "近三月") {
      return lastThreeMonths.join(",") + "月";
    }
    return `${year}年${month}月`;
  }, [timeMode, year, month, lastThreeMonths]);

  const [topList, setTopList] = useState([]);

  useEffect(() => {
    getTotal();
  }, [timeMode, year, month]);
  useEffect(() => {
    getTopCustomer();
  }, [timeMode, year, month, tParam]);
  useEffect(() => {
    getUpgradeCustomer();
  }, [timeMode, year, month, cParam]);
  useEffect(() => {
    initChart();
  }, [topParam]);
  const scrollToTop20 = () => {
    curr.current?.scrollTo({ top: size * 10 + 35, behavior: "smooth" });
  };

  const scrollToRank = () => {
    const rankElement = topRef.current;
    const rect = rankElement.getBoundingClientRect();
    // setType("升降榜");
    curr.current?.scrollTo({
      top: rect.height - size * 2 - 5,
      behavior: "smooth",
    });
    // rankRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const getTotal = useCallback(async () => {
    const res = await getAnalysis({
      type: timeMode === "本年" ? 1 : timeMode === "近三月" ? 2 : 3,
      year: timeMode !== "近三月" ? year : "",
      month: timeMode === "按月" ? month : "",
    });
    if (res && res.status === 200 && res.data.code >= 1) {
      setTotalParam(res.data.data);
    }
  }, [timeMode, year, month]);
  const getTopCustomer = async () => {
    const res = await top_customer({
      type: timeMode === "本年" ? 1 : timeMode === "近三月" ? 2 : 3,
      year: timeMode !== "近三月" ? year : "",
      month: timeMode === "按月" ? month : "",
      order: tParam.order === "出货量" ? "jxskz" : "ml",
      top: tParam.top === "TOP20" ? 20 : tParam.top === "TOP50" ? 50 : 100,
    });
    if (res && res.status === 200 && res.data.code >= 1) {
      setTopParam(res.data.data);
    }
  };
  const getUpgradeCustomer = async () => {
    const res = await upgrade_customer({
      type: timeMode === "本年" ? 1 : timeMode === "近三月" ? 2 : 3,
      year: timeMode !== "近三月" ? year : "",
      month: timeMode === "按月" ? month : "",
      order: cParam.order === "出货量" ? "jxskz" : "ml",
      top:
        cParam.top === "TOP20"
          ? 20
          : cParam.top === "TOP50"
            ? 50
            : cParam.top === "TOP150"
              ? 150
              : 100,
      trend: cParam.trend === "上升榜" ? 1 : 2,
    });
    if (res && res.status === 200 && res.data.code >= 1) {
      setTopList(res.data.data);
    }
  };
  const initChart = () => {
    let data = [];
    if (tParam.order === "出货量") {
      data = [
        {
          value: Number(topParam.top_cus_jxskz).toFixed(2),
          name: tParam.top,
          itemStyle: { color: "#3F95C2" },
        },
        {
          value: Number(topParam.other_cus_jxskz).toFixed(2),
          name: "其他客户",
          itemStyle: { color: "#f0f0f0" },
        },
      ];
    } else {
      data = [
        {
          value: Number(topParam.top_cus_ml).toFixed(2),
          name: tParam.top,
          itemStyle: { color: "#3F95C2" },
        },
        {
          value: Number(topParam.other_cus_ml).toFixed(2),
          name: "其他客户",
          itemStyle: { color: "#f0f0f0" },
        },
      ];
    }
    // const width = document.getElementById("pieChart").clientWidth - 180;
    const chart = echarts.init(document.getElementById("pie-charts"));
    const option = {
      title: {
        left: "center",
        top: "12",
        text: tParam.top + tParam.order + "占比",
        textStyle: {
          fontSize: 13,
          fontWeight: 600,
        },
      },
      tooltip: {
        trigger: "item",
      },
      legend: {
        orient: "vertical",
        // orient: "horizontal",
        // left: "center",
        left: "0",
        top: "12",
        // itemGap: width,
        selectedMode: false,
      },
      series: [
        {
          name: tParam.order,
          silent: true, // 关键配置：禁用响应事件
          label: {
            formatter: function (data) {
              let dw = "kg";
              if (tParam.order === "毛利") {
                dw = "万元";
              }
              if (data.name === tParam.top) {
                return `${data.name}\n{a|${data.percent}%}\n{c|${data.value}}${dw}`;
              } else {
                return `${data.name}\n{b|${data.percent}%}\n${data.value}${dw}`;
              }
            },
            rich: {
              c: {
                color: "#3F95C2",
              },
              a: {
                padding: [2, 0],
              },
              b: {
                padding: [2, 0],
              },
            },
            fontSize: 12,
          },

          type: "pie",
          radius: ["40%", "60%"],
          center: ["50%", "60%"],
          data,
        },
      ],
    };
    chart.setOption(option);
  };

  const handleScroll = () => {
    const top20Element = top20Ref.current;
    const rankElement = rankRef.current;
    const height = size * 12.3 + 35;
    if (top20Element) {
      const rect = top20Element.getBoundingClientRect();
      if (rect.top <= height && rect.bottom - height > 0) {
        setShowFloat(true);
        setType("客户分析");
      } else if (rankElement && rect.top < 0) {
        const rect2 = rankElement.getBoundingClientRect();
        if (rect2.top <= height) {
          setType("升降榜");
          setShowFloat(true);
        } else {
          setShowFloat(true);
        }
      } else {
        setShowFloat(false);
      }
    }
  };
  return (
    <div ref={curr} className="custom-analysis-page" onScroll={handleScroll}>
      <div className="header-custom">
        <Header title="客户分析" icon={false} />

        <div
          style={{
            position: "fixed",
            top: "4px",
            right: "10px",
            zIndex: 999,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Segmented
            options={["本年", "近三月", "按月"]}
            size="small"
            value={timeMode}
            onChange={(value) => {
              setTimeMode(value);
            }}
          />
          {timeMode === "按月" ? (
            <div
              style={{ paddingLeft: "0.5rem" }}
              onClick={() => {
                setPickVisible(true);
              }}
            >
              {currentLabel} <DownOutlined />
            </div>
          ) : (
            <div style={{ paddingLeft: "0.5rem" }}>{currentLabel}</div>
          )}
        </div>
      </div>
      <div className="analysis-summary-card-bg">
        <div className="analysis-summary-card">
          <div className="analysis-summary-date">
            数据时间：{totalParam.time}
          </div>
          <div className="summary-card-row">
            <div className="summary-card-item">
              <div className="summary-card-title">总出货量</div>
              <div className="summary-card-value">{totalParam.sum_jxskz}k</div>
              {totalParam.jxskz_growth_rate > 0 ? (
                <div className="summary-card-change">
                  ↑{" "}
                  <span className="summary-card-num">
                    {" "}
                    {totalParam.jxskz_growth_rate}%
                  </span>
                </div>
              ) : totalParam.jxskz_growth_rate === 0 ? (
                <div className="summary-card-change">0%</div>
              ) : (
                <div className="summary-card-change down">
                  ↓{" "}
                  <span className="summary-card-num">
                    {" "}
                    {Math.abs(totalParam.jxskz_growth_rate)}%
                  </span>
                </div>
              )}
            </div>
            <div className="summary-card-item">
              <div className="summary-card-title">总毛利</div>
              <div className="summary-card-value">{totalParam.sum_ml}W</div>

              {totalParam.jml_growth_rate > 0 ? (
                <div className="summary-card-change">
                  ↑{" "}
                  <span className="summary-card-num">
                    {" "}
                    {totalParam.jml_growth_rate}%
                  </span>
                </div>
              ) : totalParam.jml_growth_rate === 0 ? (
                <div className="summary-card-change">0%</div>
              ) : (
                <div className="summary-card-change down">
                  ↓{" "}
                  <span className="summary-card-num">
                    {" "}
                    {Math.abs(totalParam.jml_growth_rate)}%
                  </span>
                </div>
              )}
            </div>
            <div className="summary-card-item">
              <div className="summary-card-title">交易客户数</div>
              <div className="summary-card-value">
                {totalParam.ssjt_count}家
              </div>
              {totalParam.ssjt_count_growth_rate > 0 ? (
                <div className="summary-card-change">
                  ↑{" "}
                  <span className="summary-card-num">
                    {" "}
                    {totalParam.ssjt_count_growth_rate}%
                  </span>
                </div>
              ) : totalParam.ssjt_count_growth_rate === 0 ? (
                <div className="summary-card-change">0%</div>
              ) : (
                <div className="summary-card-change down">
                  ↓{" "}
                  <span className="summary-card-num">
                    {" "}
                    {Math.abs(totalParam.ssjt_count_growth_rate)}%
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {showFloat ? (
        <div className="analysis-summary-fiexd-qh">
          <div className="analysis-summary-fiexd-qh-box">
            <div className="qh-item" onClick={scrollToTop20}>
              <div>客户分析</div>
              {type === "客户分析" && <div className="qh-selected"></div>}
            </div>
            <div className="qh-item" onClick={scrollToRank}>
              <div>升降榜</div>
              {type === "升降榜" && <div className="qh-selected"></div>}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="analysis-section" ref={topRef}>
        <div className="ipd">
          <div className="ipd-title">
            <div className="ipd-title-name">
              <div className="ipd-title-bz"></div>
              TOP客户分析
              <Select
                size="small"
                value={tParam.top}
                onChange={(value) => {
                  tParam.top = value;
                  setTParam({ ...tParam });
                }}
                style={{ width: "6.5rem", marginLeft: "0.5rem" }}
                options={[
                  { label: "TOP20", value: "TOP20" },
                  { label: "TOP50", value: "TOP50" },
                  { label: "TOP100", value: "TOP100" },
                ]}
              />
            </div>
            <div>
              <Segmented
                options={["出货量", "毛利"]}
                size="small"
                value={tParam.order}
                className="ipd-segmented"
                onChange={(value) => {
                  tParam.order = value;
                  setTParam({ ...tParam });
                }}
              />
            </div>
          </div>
          <div>
            <div id="pie-charts"></div>
          </div>
        </div>
        <div ref={top20Ref}>
          <div className="analysis-section-title">{tParam.top}客户出货量表</div>
          <div className="analysis-table-wrap">
            <table className="analysis-table">
              <thead>
                <tr>
                  <th>排名</th>
                  <th>客户名</th>
                  <th>出货量</th>
                  <th>毛利</th>
                </tr>
              </thead>
              <tbody>
                {topParam.cus_list.map((item) => (
                  <tr key={item.rank}>
                    {item.rank > 5 ? (
                      <td>{item.rank}</td>
                    ) : item.rank == 1 ? (
                      <td>
                        <img
                          style={{ width: "1.3rem", height: "1.3rem" }}
                          src={require("../../asset/image/custom/top1.png")}
                          alt=""
                        />
                      </td>
                    ) : item.rank == 2 ? (
                      <td>
                        <img
                          style={{ width: "1.3rem", height: "1.3rem" }}
                          src={require("../../asset/image/custom/top2.png")}
                          alt=""
                        />
                      </td>
                    ) : item.rank == 3 ? (
                      <td>
                        <img
                          style={{ width: "1.3rem", height: "1.3rem" }}
                          src={require("../../asset/image/custom/top3.png")}
                          alt=""
                        />
                      </td>
                    ) : item.rank == 4 ? (
                      <td>
                        <img
                          style={{ width: "1.3rem", height: "1.3rem" }}
                          src={require("../../asset/image/custom/top4.png")}
                          alt=""
                        />
                      </td>
                    ) : (
                      <td>
                        <img
                          style={{ width: "1.3rem", height: "1.3rem" }}
                          src={require("../../asset/image/custom/top5.png")}
                          alt=""
                        />
                      </td>
                    )}
                    <td
                      onClick={() => {
                        navigator("/customAnalysis/detail", {
                          state: {
                            timeMode,
                            year,
                            month,
                            lastThreeMonths,
                            ...item,
                          },
                        });
                      }}
                    >
                      <span style={{ borderBottom: "1px solid #000" }}>
                        {item.ssjt}
                      </span>
                    </td>
                    <td className={tParam.order === "出货量" ? "td-bs" : ""}>
                      {item.jxskz}K
                    </td>
                    <td className={tParam.order === "毛利" ? "td-bs" : ""}>
                      {item.ml}W
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="tfoot">
                  <td></td>
                  <td>总计</td>
                  <td>{topParam.top_cus_jxskz.toFixed(2)}</td>
                  <td>{topParam.top_cus_ml.toFixed(2)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div
        className="analysis-section"
        style={{ marginTop: "10px" }}
        ref={rankRef}
      >
        <div className="ipd">
          <div className="ipd-title">
            <div className="ipd-title-name">
              <div className="ipd-title-bz"></div>
              客户升降榜
              <Select
                size="small"
                value={cParam.top}
                onChange={(value) => {
                  setCParam({ ...cParam, top: value });
                }}
                style={{ width: "6.5rem", marginLeft: "0.5rem" }}
                options={[
                  { label: "前20名", value: "TOP20" },
                  { label: "前50名", value: "TOP50" },
                  { label: "前100名", value: "TOP100" },
                  { label: "前150名", value: "TOP150" },
                ]}
              />
            </div>
            <div>
              <Segmented
                options={["出货量", "毛利"]}
                size="small"
                value={cParam.order}
                className="ipd-segmented"
                onChange={(value) => {
                  setCParam({ ...cParam, order: value });
                }}
              />
            </div>
          </div>
          <div>
            <div className="custom-type-row">
              <div
                className={
                  cParam.trend === "上升榜"
                    ? "custom-type-item2"
                    : "custom-type-item"
                }
                onClick={() => {
                  if (cParam.tParam === "上升榜") return;
                  setCParam({ ...cParam, trend: "上升榜" });
                }}
              >
                上升榜
              </div>

              <div
                className={
                  cParam.trend === "下降榜"
                    ? "custom-type-item2"
                    : "custom-type-item"
                }
                onClick={() => {
                  if (cParam.tParam === "下降榜") return;
                  setCParam({ ...cParam, trend: "下降榜" });
                }}
              >
                下降榜
              </div>
            </div>
            {/* <div id="pieChart"></div> */}
          </div>
        </div>
        <div className="analysis-table-wrap">
          <table className="analysis-table">
            <thead>
              <tr>
                <th style={{ width: "40px" }}>排名</th>
                <th>客户</th>
                <th style={{ minWidth: "50px" }}>上期值</th>
                <th style={{ minWidth: "50px" }}>本期值</th>
                <th>{cParam.trend === "上升榜" ? "上升值" : "下降值"}</th>
              </tr>
            </thead>
            <tbody>
              {topList.map((item, index) => (
                <tr key={item.rank}>
                  <td>
                    {item.rank <= 3 && cParam.trend === "上升榜" ? (
                      <img
                        style={{ width: "1.3rem", height: "1.3rem" }}
                        src={require("../../asset/image/custom/hot.png")}
                        alt=""
                      />
                    ) : item.rank <= 3 && cParam.trend === "下降榜" ? (
                      <img
                        style={{ width: "1.3rem", height: "1.3rem" }}
                        src={require("../../asset/image/custom/warn.png")}
                        alt=""
                      />
                    ) : (
                      item.rank
                    )}{" "}
                  </td>
                  <td
                    onClick={() => {
                      navigator("/customAnalysis/detail", {
                        state: {
                          timeMode,
                          year,
                          month,
                          lastThreeMonths,
                          ...item,
                        },
                      });
                    }}
                  >
                    <span style={{ borderBottom: "1px solid #000" }}>
                      {item.ssjt}
                    </span>
                  </td>
                  <td>
                    {cParam.order === "出货量"
                      ? item.total_xskz_last_year
                      : item.total_ml_last_year}
                    {cParam.order === "出货量" ? "K" : "W"}
                  </td>
                  <td>
                    {cParam.order === "出货量" ? item.sum_jxskz : item.sum_ml}
                    {cParam.order === "出货量" ? "K" : "W"}
                  </td>
                  <td>
                    {cParam.order === "出货量"
                      ? item.xskz_growth_rate_percent + "K"
                      : item.ml_growth_rate_percent + "W"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div style={{ height: "100px" }}></div>
      <DatePicker
        visible={pickVisible}
        precision="month"
        min={new Date(2026, 0, 1)}
        max={new Date()}
        onClose={() => setPickVisible(false)}
        onConfirm={(date) => {
          setYear(date.getFullYear());
          setMonth(date.getMonth() + 1);
          setPickVisible(false);
        }}
      />
    </div>
  );
}
